export const fileTypes: string =
  process.env.REACT_APP_PIECE_JOINTE_ACCEPTED_TYPES ||
  'application/pdf,image/png,image/jpeg';
export const maxFileSize =
  process.env.REACT_APP_PIECE_JOINTE_MAX_SIZE || '10485760';
